import type { DeskLayout } from '../models/desk-layout.model';

export const P35_DESKS: DeskLayout[] = [
  { name: 'M1', x: 54, y: 258.659, w: 43.214, h: 47.8448, rx: 9, reservationId: 414 },
  { name: 'M2', x: 102, y: 258.659, w: 43.214, h: 47.8448, rx: 9, reservationId: 415 },
  { name: 'M3', x: 150, y: 258.659, w: 43.214, h: 47.8448, rx: 9, reservationId: 416 },
  { name: 'M4', x: 54, y: 310.804, w: 43.214, h: 47.8448, rx: 9, reservationId: 417 },
  { name: 'M5', x: 102, y: 310.804, w: 43.214, h: 47.8448, rx: 9, reservationId: 418 },
  { name: 'M6', x: 150, y: 310.804, w: 43.214, h: 47.8448, rx: 9, reservationId: 419 },
  { name: 'M7', x: 54, y: 388.828, w: 43.214, h: 47.8448, rx: 9, reservationId: 420 },
  { name: 'M8', x: 102, y: 388.828, w: 43.214, h: 47.8448, rx: 9, reservationId: 421 },
  { name: 'M9', x: 150, y: 388.828, w: 43.214, h: 47.8448, rx: 9, reservationId: 422 },
  { name: 'M10', x: 54, y: 440.973, w: 43.214, h: 47.8448, rx: 9, reservationId: 423 },
  { name: 'M11', x: 102, y: 440.973, w: 43.214, h: 47.8448, rx: 9, reservationId: 424 },
  { name: 'M12', x: 150, y: 440.973, w: 43.214, h: 47.8448, rx: 9, reservationId: 425 },
  { name: 'M13', x: 54, y: 518.012, w: 43.214, h: 47.8448, rx: 9, reservationId: 426 },
  { name: 'M14', x: 102, y: 518.012, w: 43.214, h: 47.8448, rx: 9, reservationId: 427 },
  { name: 'M15', x: 150, y: 518.012, w: 43.214, h: 47.8448, rx: 9, reservationId: 428 },
  { name: 'M16', x: 54, y: 570.156, w: 43.214, h: 47.8448, rx: 9, reservationId: 429 },
  { name: 'M17', x: 102, y: 570.156, w: 43.214, h: 47.8448, rx: 9, reservationId: 430 },
  { name: 'M18', x: 150, y: 570.156, w: 43.214, h: 47.8448, rx: 9, reservationId: 431 },
  { name: 'M19', x: 264, y: 518.012, w: 43.214, h: 47.8448, rx: 9, reservationId: 432, liftDesk: true },
  { name: 'M20', x: 312, y: 518.012, w: 43.214, h: 47.8448, rx: 9, reservationId: 433 },
  { name: 'M21', x: 360, y: 518.012, w: 43.214, h: 47.8448, rx: 9, reservationId: 434 },
  { name: 'M22', x: 264, y: 570.156, w: 43.214, h: 47.8448, rx: 9, reservationId: 435, liftDesk: true },
  { name: 'M23', x: 312, y: 570.156, w: 43.214, h: 47.8448, rx: 9, reservationId: 436 },
  { name: 'M24', x: 360, y: 570.156, w: 43.214, h: 47.8448, rx: 9, reservationId: 437 },

  { name: 'M41', x: 493, y: 92.883, w: 43.214, h: 47.8448, rx: 9, reservationId: 454 },
  { name: 'M42', x: 445, y: 92.883, w: 43.214, h: 47.8448, rx: 9, reservationId: 455 },

  { name: 'M43', x: 397, y: 92.883, w: 43.214, h: 47.8448, rx: 9, reservationId: 456 },
  { name: 'M44', x: 493, y: 39.7379, w: 43.214, h: 47.8448, rx: 9, reservationId: 457 },
  { name: 'M45', x: 445, y: 39.7379, w: 43.214, h: 47.8448, rx: 9, reservationId: 458 },
  { name: 'M46', x: 397, y: 39.7379, w: 43.214, h: 47.8448, rx: 9, reservationId: 459 },

  { name: 'M25', x: 318, y: 249.491, w: 43.8218, h: 47.1813, rx: 9, reservationId: 438 },
  { name: 'M29', x: 366.822, y: 249.491, w: 43.8218, h: 47.1813, rx: 9, reservationId: 442 },
  { name: 'M30', x: 366.822, y: 302.742, w: 43.8218, h: 47.1813, rx: 9, reservationId: 443 },
  { name: 'M27', x: 318, y: 355.993, w: 43.8218, h: 47.1813, rx: 9, reservationId: 440 },
  { name: 'M26', x: 318, y: 302.742, w: 43.8218, h: 47.1813, rx: 9, reservationId: 439 },
  { name: 'M31', x: 366.822, y: 355.993, w: 43.8218, h: 47.1813, rx: 9, reservationId: 444 },
  { name: 'M28', x: 318, y: 408.258, w: 43.8218, h: 47.1813, rx: 9, reservationId: 441, liftDesk: true },
  { name: 'M32', x: 367, y: 408.258, w: 43.8218, h: 47.1813, rx: 9, reservationId: 445, liftDesk: true },

  { name: 'M33', x: 443, y: 249.491, w: 43.8218, h: 47.1813, rx: 9, reservationId: 446 },
  { name: 'M37', x: 491.822, y: 249.491, w: 43.8218, h: 47.1813, rx: 9, reservationId: 450 },
  { name: 'M38', x: 491.822, y: 302.742, w: 43.8218, h: 47.1813, rx: 9, reservationId: 451 },
  { name: 'M35', x: 443, y: 355.993, w: 43.8218, h: 47.1813, rx: 9, reservationId: 448 },
  { name: 'M34', x: 443, y: 302.742, w: 43.8218, h: 47.1813, rx: 9, reservationId: 447 },
  { name: 'M39', x: 491.822, y: 355.993, w: 43.8218, h: 47.1813, rx: 9, reservationId: 452 },
  { name: 'M36', x: 443, y: 408.258, w: 43.8218, h: 47.1813, rx: 9, reservationId: 449 },
  { name: 'M40', x: 492, y: 408.258, w: 43.8218, h: 47.1813, rx: 9, reservationId: 453 }
];